<div class="modal-header">
  <h4 class="modal-title">{{'proTasks.form.confirm.title' | translate}}</h4>
</div>

<div class="modal-body">
  <p>{{'proTasks.form.confirm.message' | translate}}</p>
</div>

<div class="modal-footer">
  <button type="button" class="form__action--primary" (click)="activeModal.close()" role="button">
    <i class="ico-check"></i>
    {{'proTasks.form.confirm.save' | translate}}
  </button>
  <button type="button" class="form__action--danger" (click)="activeModal.dismiss()" role="button">
    <i class="ico-close"></i>
    {{'proTasks.form.confirm.cancel' | translate}}
  </button>
</div>
